// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-user-access-form h4{margin-bottom:1rem}.location-user-access-form button{height:36px}", ""]);
// Exports
module.exports = exports;
